import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { useTooltip } from '@frontend/design-system';

type BlockedIconProps = {
  size?: number;
};

export const BlockedIcon = ({ size = 16 }: BlockedIconProps) => {
  const { t } = useTranslation('calls');
  const { tooltipProps, triggerProps, Tooltip } = useTooltip({ placement: 'top' });

  return (
    <>
      <span css={styles.wrapper} data-testid='blocked-icon' {...triggerProps}>
        <Icon name='block' size={size} />
      </span>
      <Tooltip {...tooltipProps}>{t('Blocked')}</Tooltip>
    </>
  );
};

const styles = {
  wrapper: css`
    display: inline-flex;
    align-items: center;
  `,
};
